























import { CustomTableVue } from "../vueModels/app/CustomTableVue";
import { Component } from "vue-property-decorator";

@Component()
export default class CustomTable extends CustomTableVue {}
